var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdFortuneTellerEvent } from "../../constants/IdFortuneTellerEvent";
import { utilTime } from "../../utils/utilTime";
import { TypeActionFortuneTellerEventInfo, } from "./actionFortuneTellerEventInfo";
var initial = {
    cooldownTime: 0,
    currentStep: 0,
    difficulty: 0,
};
export var reducerFortuneTellerEventInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionFortuneTellerEventInfo.Received:
            if (action.fortune) {
                return __assign({}, state, { currentStep: action.fortune.currentStep || 0, difficulty: action.fortune.difficulty || 0 });
            }
            break;
        case TypeActionFortuneTellerEventInfo.RequestBuyPackage:
            return __assign({}, state, { cooldownTime: utilTime.timestamp(IdFortuneTellerEvent.BuyPackageCoolDownTime) });
        case TypeActionFortuneTellerEventInfo.FinishBuyPackageCoolDown:
            return __assign({}, state, { cooldownTime: 0 });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/reducerFortuneTellerEventInfo.ts
// module id = 2529
// module chunks = 3